/**
 * Logic to control UX on the folder upload page.
 */
let selectedUploadType = 'folder';
let mediaUploadForm = document.querySelector('#media-upload-form');
let mediaUploadProgress = document.querySelector('#media-upload-progress');

let seriesInput = mediaUploadForm?.querySelector('#id_series');
let folderInput = mediaUploadForm?.querySelector('#id_folder_picker');
let fileInput = mediaUploadForm?.querySelector('#id_file_picker');
let sourceUrlInput = mediaUploadForm?.querySelector('#id_source_url');
let submitBtn = mediaUploadForm?.querySelector('button[type=submit]');
let resetBtn = mediaUploadForm?.querySelector('button[type=reset]');
// dynamic form fields
let uploadType = mediaUploadForm?.querySelector('#upload_type');
let uploadTypeFieldset = uploadType?.querySelector('fieldset');
let sourceUrl = mediaUploadForm?.querySelector('#source_url');
let filePicker = mediaUploadForm?.querySelector('#file_picker');
let folderPicker = mediaUploadForm?.querySelector('#folder_picker');
// folder upload
let logList = mediaUploadProgress?.querySelector('#log-list');
let summaryOtherErrors = mediaUploadProgress?.querySelector('#summary-other-errors');
let summaryUnprocessable = mediaUploadProgress?.querySelector('#summary-unprocessable');
let summaryFileExists = mediaUploadProgress?.querySelector('#summary-file-exists');
let successCheckmark = mediaUploadProgress?.querySelector('.success-checkmark');
let progressBarFill = mediaUploadProgress?.querySelector('.progress-fill');

// disable/enable the submit button depending on if files are specified
seriesInput?.addEventListener('input', (event) => {
    if (selectedUploadType === 'file') {
        handleEnablingSubmit(seriesInput, fileInput, submitBtn);
    } else {
        handleEnablingSubmit(seriesInput, folderInput, submitBtn);
    }
});
folderInput?.addEventListener('change', (event) => {
   handleEnablingSubmit(seriesInput, folderInput, submitBtn);
});
fileInput?.addEventListener('change', (event) => {
   handleEnablingSubmit(seriesInput, fileInput, submitBtn);
   // source url input should only be provided when there is a single file
   if (sourceUrlInput && event.target.files.length !== 1) {
       sourceUrlInput.disabled = true;
   } else if (sourceUrlInput) {
       sourceUrlInput.disabled = false;
   }
});

resetBtn?.addEventListener('click', (event) => {
    // disable submit button on form reset
    submitBtn?.classList.add('disabled-btn');
    // re-enable the sourceUrlInput on form reset
    if (sourceUrlInput && selectedUploadType === 'file') {
        sourceUrlInput.disabled = false;
    }
});

// connect the dynamic form elements
uploadTypeFieldset?.addEventListener('change', event => {
    selectedUploadType = event.target.value;
    if (selectedUploadType === 'file') {
        folderPicker?.classList.add('u-hidden');
        filePicker?.classList.remove('u-hidden');
        if (fileInput?.files.length <= 1) {
            sourceUrl?.classList.remove('u-hidden');
        }
        handleEnablingSubmit(seriesInput, fileInput, submitBtn);
    } else {
        filePicker?.classList.add('u-hidden');
        folderPicker?.classList.remove('u-hidden');
        sourceUrl?.classList.add('u-hidden');
        handleEnablingSubmit(seriesInput, folderInput, submitBtn);
    }
})

// submit files to endpoint
submitBtn?.addEventListener('click', async (event) => {
    event.preventDefault();
    if (seriesInput?.value.trim() == null) {
        // user can still hit enter and submit the form a series
        // so just return early and don't process the request.
        return
    }

    let formData = new FormData(mediaUploadForm);
    const csrfToken = formData.get('csrfmiddlewaretoken');
    const series = formData.get('series');
    const pageUrl = formData.get('page_url');
    const noticeType = formData.get('notice_type');
    let sourceUrl = null;

    let files = []
    if (selectedUploadType === 'file') {
        files = formData.getAll('file_picker');
        // user can still hit enter and submit the form without any files,
        // so just return early and don't process the request.
        if (fileInput.files.length === 0) {
            return
        } else if (fileInput.files.length === 1) {
            // only single file uploads may have a source url
            sourceUrl = formData.get('source_url');
        }
    } else {
        files = formData.getAll('folder_picker');
        // user can still hit enter and submit the form without any files,
        // so just return early and don't process the request.
        if (folderInput.files.length === 0) {
            return
        }
    }

    // file count for displaying upload progress
    let fileCount = mediaUploadProgress.querySelector('#media-upload-file-count');
    let currentFileCount = 0;
    fileCount.innerHTML = '(' + currentFileCount + '/' + files.length + ')';
    mediaUploadForm.classList.add('hidden');
    mediaUploadProgress.classList.remove('hidden');
    // each file is a separate submission
    for (currentFileCount = 0; currentFileCount < files.length; currentFileCount++) {
        const file = files[currentFileCount];
        // show that the file is being processed in frontend
        let filename = selectedUploadType === 'file' ? file.name : file.webkitRelativePath;
        const newLogItem = document.createElement('li');
        const itemName = document.createTextNode('[' + filename + '] ');
        const itemLoadingStatus = document.createElement('span');
        itemLoadingStatus.classList.add('spinner');
        newLogItem.classList.add('file-upload-result-item');
        newLogItem.appendChild(itemName);
        newLogItem.appendChild(itemLoadingStatus);
        logList.insertBefore(newLogItem, logList.firstChild);
        // load data and send file to backend
        let postData = new FormData();
        postData.append('series', series);
        postData.append('relative_filename', filename);
        postData.append('file', file);
        postData.append('page_url', pageUrl);
        if (sourceUrl) {
            postData.append('source_url', sourceUrl);
        }
        if (noticeType) {
            postData.append('notice_type', noticeType);
        }

        await fetch('', {
            method: 'POST',
            headers: {
                'X-CSRFToken': csrfToken,
            },
            body: postData
        }).then((response) => {
            response.json().then((json) => {
                // update summary sections
                let newListItem = document.createElement('li');
                newListItem.innerHTML = filename;
                if (response.status === 409) {
                    summaryFileExists.insertBefore(
                        newListItem,
                        summaryFileExists.firstChild
                    );
                } else if (response.status === 415) {
                    summaryUnprocessable.insertBefore(
                        newListItem,
                        summaryUnprocessable.firstChild
                    );
                } else if (response.status >= 400) {
                    summaryOtherErrors.insertBefore(
                        newListItem,
                        summaryOtherErrors.firstChild
                    )
                }
                // update result in the log
                const itemUploadResult = document.createElement('span');
                itemUploadResult.innerHTML = json.result
                if (response.status === 200 || response.status === 409) {
                    itemUploadResult.classList.add('success-file-upload');
                } else {
                    itemUploadResult.classList.add('error-file-upload');
                }
                newLogItem.replaceChild(itemUploadResult, itemLoadingStatus);
            });
        }).catch((error) => {
            error.json().then((json) => {
                let newListItem = document.createElement('li');
                newListItem.innerHTML = filename;
                summaryOtherErrors.insertBefore(
                    newListItem,
                    summaryOtherErrors.firstChild
                )
                // update result in the log
                const itemUploadResult = document.createElement('span');
                itemUploadResult.innerHTML = json.result;
                newLogItem.replaceChild(itemUploadResult, itemLoadingStatus);
            });
        }).finally(() => {
            progressBarFill.style.width = '' + (((currentFileCount + 1) / files.length) * 100) + '%';
            fileCount.innerHTML = '(' + (currentFileCount + 1) + '/' + files.length + ')';
        });
    }
    successCheckmark.classList.remove('hidden');
});

function handleEnablingSubmit(seriesInput, uploadInput, submitBtn) {
    if (uploadInput?.files.length > 0 && seriesInput?.value.trim()) {
        submitBtn?.classList.remove('disabled-btn');
    } else {
        submitBtn?.classList.add('disabled-btn');
    }
}
